import React from 'react'
import PropTypes from 'prop-types'
import { Button, Form, Upload, message } from 'antd'

const FormItem = Form.Item

function normUploadFileList (e) {
  if (Array.isArray(e)) return e
  return e && e.fileList ? e.fileList : []
}

class ScheduleImportForm extends React.Component {
  static propTypes = {
    form: PropTypes.object
  }

  componentDidMount () {
    this.syncRecord()
  }

  syncRecord = () => {
    const { form } = this.props
    if (!form || !form.current) return
    form.current.setFieldsValue({
      file: []
    })
  }

  beforeUploadExcel = (file) => {
    const name = file && file.name ? String(file.name).toLowerCase() : ''
    const ok = name.endsWith('.xlsx') || name.endsWith('.xls')
    if (!ok) {
      message.error('仅支持 xlsx / xls')
      return Upload.LIST_IGNORE
    }
    return false
  }

  render () {
    const { form } = this.props
    return (
      <Form ref={form} layout="vertical">
        <FormItem
          label="Excel"
          name="file"
          valuePropName="fileList"
          getValueFromEvent={normUploadFileList}
          extra="仅支持 .xlsx / .xls。"
          rules={[{
            validator: (_, fileList) => {
              const list = Array.isArray(fileList) ? fileList : []
              const file = list[0] && list[0].originFileObj
              if (!file) return Promise.reject(new Error('请选择 Excel 文件'))
              return Promise.resolve()
            }
          }]}
        >
          <Upload
            maxCount={1}
            accept=".xlsx,.xls"
            beforeUpload={this.beforeUploadExcel}
          >
            <Button size="large">选择文件</Button>
          </Upload>
        </FormItem>
      </Form>
    )
  }
}

export default ScheduleImportForm
